/**
 * @cogo/validation-rules
 *
 * Shared validation rules for Cogo block generation and validation.
 * Pure functions — no Node.js, Deno, or framework dependencies.
 *
 * Used by:
 *   - @cogo/validator (client-side validation)
 *   - cogo-agent generation pipeline (server-side feedback loop)
 *   - Cloudflare/Edge Functions (prompt hardening)
 */

export type {
  RuleViolation,
  BlockData,
  FeatureRule,
  PromptFeedback,
} from "./types"

export {
  checkAllRules,
  getAllRules,
  checkRule,
} from "./features"

export {
  generateFeedback,
  violationsToFeedback,
  formatFeedbackForPrompt,
  getFeaturePatternRules,
} from "./feedback"
